import {GetHealthRequestSchedulePermissionParams} from 'domain/usecases/private/booking-flow/health/get-health-request-schedule-permission';
import {makeGetHealthRequestSchedulePermission} from 'main/factories/usecases/private/booking-flow/remote-health-booking/get-health-request-schedule-permission-factory';

export async function getHealthRequestSchedulePermission(
	params: GetHealthRequestSchedulePermissionParams,
) {
	const response = await makeGetHealthRequestSchedulePermission().get(params);

	return response;
}
